// src/components/AdminAddProduct.jsx
import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Input, Label } from 'reactstrap';
import MyStorage from './util/storage';
import { Oval as Loader } from 'react-loader-spinner';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast';
import { db1, storage1 } from '../../firebase/firebase1';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import add from '../assets/add.png';
import cross from '../assets/delete.png';
import Resizer from 'react-image-file-resizer';

// import { getFirestore, collection, getDocs, writeBatch } from "firebase/firestore";
// async function fixCategoriesToArray() {
//   const db = getFirestore();
//   const productsRef = collection(db, "products");
//   const snapshot = await getDocs(productsRef);
//   const batch = writeBatch(db);
//   let count = 0;
//   snapshot.forEach(doc => {
//     const data = doc.data();
//     // Only update if category is a string
//     if (typeof data.category === "string") {
//       batch.update(doc.ref, {
//         category: [data.category]
//       });
//       count++;
//     }
//   });
//   if (count > 0) {
//     await batch.commit();
//     console.log(`✅ Updated ${count} products`);
//   } else {
//     console.log("✅ Nothing to update");
//   }
// }

let i = 1;
let imageUrls = [];

const slugify = (text = '') => {
  return text.toString().toLowerCase().trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
};

const AddProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const model = location.state?.model;
  const editMode = model != null;

  const [productId, setProductId] = useState(editMode ? model.id : '');
  const [title, setTitle] = useState(editMode ? model.title : '');
  const [brand, setBrand] = useState(editMode ? model.brand : '');
  const [manufacturer, setManufacturer] = useState(editMode ? model.manufacturer : '');
  const [expiryDate, setExpiryDate] = useState(editMode ? model.expiry_date : '');
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [images, setImages] = useState([{}]);
  const addScreenshot = useRef(null);
  const [loader, setLoader] = useState(false);

  const [saving, setSaving] = useState(false);

  const [rating, setRating] = useState(editMode ? (model.rating || { avg: 0, count: 0 }) : { avg: 0, count: 0 });
  const [featured, setFeatured] = useState(editMode ? model.featured : 0);
  const [directions, setDirections] = useState(editMode ? (model.directions || '') : '');

  // category is now an array of selected categories
  const [category, setCategory] = useState(
    editMode
      ? (Array.isArray(model.category) ? model.category : (model.category ? [model.category] : ['otc']))
      : ['otc']
  );

  const [price, setPrice] = useState(editMode ? model.price : '0');

  useEffect(() => {
    if (editMode) {
      // Load description
      if (model.description) {
        const blocksFromHTML = convertFromHTML(model.description);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );
        setEditorState(EditorState.createWithContent(contentState));
      }

      // Load images
      let imgs = [{}];
      for (let j = 0; j < (model.images || []).length; j++) {
        imgs = imgs.concat({ file: null, url: model.images[j], name: '' });
        if (j === model.images.length - 1) setImages(imgs);
      }

      // Ensure category is an array in state (backwards compatibility if saved as string)
      if (model.category) {
        setCategory(Array.isArray(model.category) ? model.category : [model.category]);
      }
    }
  }, []);

  if (!MyStorage.isLogin()) {
    navigate('/admin/login', { replace: true });
    return null;
  }

  const onEditorStateChange = (state) => setEditorState(state);

  const resizeFile = (file) => new Promise(resolve => {
      Resizer.imageFileResizer(file, 1024, 1024, 'JPEG', 90, 0,
          uri => {
              resolve(uri);
          }, 'file');
  });

  const handleAddImage = async (event) => {
    let temp = [{}];
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const resizedImage = await resizeFile(file);
      let url = URL.createObjectURL(resizedImage);
      temp = temp.concat({ file: resizedImage, url: url, name: resizedImage.name });
    }
    setImages(temp);
  };

  const showProductImages = () => images.map((item, index) => {
    if (index === 0) {
      return (
        <div style={{ marginRight: 10, marginBottom: 10 }} key={index}>
          <div onClick={() => addScreenshot.current.click()} style={{ width: 100, height: 100, backgroundColor: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={add} style={{ width: 30, height: 30 }} />
            <input multiple type='file' style={{ display: 'none' }} ref={addScreenshot} onChange={handleAddImage} />
          </div>
        </div>
      );
    }
    return (
      <div key={index} style={{ display: 'inline-flex', width: 100, height: 100, marginRight: 10, marginBottom: 10 }}>
        <img src={item.url} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        <div onClick={() => {
          const temp = images.filter((_, j) => index !== j);
          setImages(temp);
        }} style={{ width: 25, height: 25, marginLeft: -25, marginTop: 0, backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={cross} style={{ width: 20, height: 20 }} />
        </div>
      </div>
    );
  });

  const saveProduct = () => {
    if (saving) {
      return
    }
    if (!title || !brand || !category || category.length === 0) {
      showToast('error', 'Please fill all required fields and select at least one category!');
      return;
    }

    const descriptionHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setLoader(true);
    setSaving(true);
    i = 1;
    imageUrls = [];
    uploadImagesAndSave(descriptionHtml);
  };

  const uploadImagesAndSave = (descriptionHtml) => {
    // collect only new images (those having a File)
    const newImages = images.filter(img => img.file);
    const existingUrls = images.filter(img => !img.file && img.url).map(img => img.url);

    // if there are no new images, just save directly
    if (newImages.length === 0) {
      saveProductToFirebase(descriptionHtml, existingUrls);
      return;
    }

    let uploadedUrls = [];
    let index = 0;

    const uploadNext = () => {
      const img = newImages[index];
      const path = `our_products/${img.name || img.file.name}`;
      uploadPhoto(path, img.file, (url) => {
        uploadedUrls.push(url);
        if (index === newImages.length - 1) {
          // merge new and existing image URLs
          const allUrls = existingUrls.concat(uploadedUrls);
          saveProductToFirebase(descriptionHtml, allUrls);
        } else {
          index++;
          uploadNext();
        }
      });
    };

    uploadNext();
  };

  const generateProductId = () => {
    if (productId) return productId;
    const t = slugify(title || 'product');
    const b = slugify(brand || 'brand');
    return `prod_${t}_${b}_${Date.now()}`;
  };

  const saveProductToFirebase = (descriptionHtml, urls) => {

    const finalRating = {
      avg: Number(rating.avg) || 0,
      count: Number(rating.count) || 0
    };

    const idToUse = editMode ? (model.id || generateProductId()) : generateProductId();

    const productData = {
      id: idToUse,
      title,
      brand,
      rating: finalRating,
      featured: featured,
      images: urls,
      directions,
      description: descriptionHtml,
      manufacturer,
      expiry_date: expiryDate,
      // ensure category is saved as an array for backward compatibility
      category: Array.isArray(category) ? category : (category ? [category] : []),
      price: price,
      added_date: Number(moment().valueOf())
    };

    const collection = db1.collection('our_products');
    if (editMode) {
      collection.doc(model.id).set(productData, { merge: true })
        .then(() => {
          setSaving(false);
          setLoader(false);
          showToast('success', 'Product updated!'); navigate(-1);
        })
        .catch(() => {
          setSaving(false);
          showToast('error', 'Failed!');
          setLoader(false);
        });
    } else {
      // create document with product id so saved product follows requested format
      collection.doc(idToUse).set(productData)
        .then(() => {
          setSaving(false);
          setLoader(false);
          showToast('success', 'Product added!');
          navigate(-1);
        })
        .catch(() => {
          setSaving(false);
          showToast('error', 'Failed!');
          setLoader(false);
        });
    }
  };

  const uploadPhoto = (path, photo, onSuccess) => {
    const uploadTask = storage1.ref(path).put(photo);
    uploadTask.on('state_changed', null, console.error, () => {
      storage1.ref(path).getDownloadURL().then(onSuccess);
    });
  };

  const allCategories = [
    { value: 'otc', label: 'OTC' },
    { value: 'orthopedic', label: 'Orthopedic' },
    { value: 'wound', label: 'Wound Care' },
    { value: 'mobility', label: 'Mobility Aids' },
    { value: 'diagnostics', label: 'Diagnostics' },
    { value: 'respiratory', label: 'Respiratory' },
    { value: 'incontinence', label: 'Incontinence' },
    { value: 'personal', label: 'Personal Care' },
    { value: 'others', label: 'Other' }
  ];

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>{editMode ? 'Edit Product' : 'Add Product'}</div>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ paddingTop: 30, paddingBottom: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflow: 'scroll' }}>
          <Form className='form' style={{ padding: 0, backgroundColor: '#f2f2f2', borderRadius: 10, minWidth: 600 }}>

            <FormGroup>
              <div style={{ color: 'gray' }}>Product Title</div>
              <Input type='text' placeholder='' value={title} onChange={e => setTitle(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <div style={{ color: 'gray' }}>Brand</div>
              <Input type='text' placeholder='' value={brand} onChange={e => setBrand(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <div style={{ color: 'gray' }}>Manufacturer</div>
              <Input type='text' placeholder='' value={manufacturer} onChange={e => setManufacturer(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <div style={{ color: 'gray' }}>Expiry</div>
              <Input type='date' placeholder='' value={expiryDate} onChange={e => setExpiryDate(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <div style={{ color: 'gray' }}>Description</div>
              <Editor
                editorStyle={{ backgroundColor: '#fafafa', paddingLeft: 10, paddingRight: 10, height: 150 }}
                editorState={editorState}
                onEditorStateChange={onEditorStateChange}
              />
            </FormGroup>

            {/* Directions */}
            <FormGroup>
              <div style={{ color: 'gray' }}>Directions / Usage</div>
              <Input type='textarea' placeholder='Directions like: Adults: 1–2 tablets every 4 hours...' value={directions} onChange={e => setDirections(e.target.value)} />
            </FormGroup>

            {/* Rating and Prescription */}
            <FormGroup style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ display: 'flex', gap: 5, alignItems: 'center', marginLeft: 0 }}>
                <Input type='checkbox' style={{ width: 20, height: 20 }} checked={featured} onChange={e => setFeatured(e.target.checked ? 1 : 0)} />
                <Label style={{ marginBottom: -2, marginLeft: 5 }}>Featured Product</Label>
              </div>
            </FormGroup>

            <FormGroup>
              <div style={{ color: 'gray' }}>Category <small style={{ color: '#999' }}> (select one or more — hold Ctrl/Cmd or Shift)</small></div>
              <Input type='select' multiple value={category} onChange={e => {
                const selected = Array.from(e.target.selectedOptions).map(o => o.value);
                setCategory(selected);
              }}>
                {allCategories.map(c => (
                  <option key={c.value} value={c.value}>{c.label}</option>
                ))}
              </Input>

              <div style={{ marginTop: 8, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {category && category.map(cat => (
                  <div key={cat} style={{ padding: '4px 8px', borderRadius: 12, backgroundColor: '#e6e6e6', fontSize: 12 }}>{allCategories.find(a => a.value === cat)?.label || cat}</div>
                ))}
              </div>
            </FormGroup>

            <FormGroup>
              <div style={{ color: 'gray' }}>Price ($)</div>
              <Input type='number' placeholder='Enter Price' value={price} onChange={e => setPrice(e.target.value)} />
            </FormGroup>

            <FormGroup>
              <div>Images:</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 5 }}>
                {showProductImages()}
              </div>
            </FormGroup>

            <Button
              className='btn-block btn-dark'
              style={{ marginTop: 15, marginBottom: 40, fontSize: 18, fontWeight: 'bold', width: '100%', backgroundColor: 'orange', borderWidth: 0, height: 50 }}
              onClick={saveProduct}>
              {editMode ? 'Update Product' : 'Save Product'}
            </Button>
          </Form>
        </div>
      </div>

      {loader &&
        <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
          <Loader type="ThreeDots" color="white" height={70} width={70} visible={true} />
        </div>
      }

      <ToastContainer />
    </div>
  );
};

export default AddProduct;
